// Copy/pasted from https://github.com/googlemaps/js-rich-marker/blob/gh-pages/src/richmarker-compiled.js
// I added "module.exports =" and removed "()" at the end of the file so that it wouldn't be initialized automatically.
// This way we can load the Google Maps library asynchonously and then initialize this file when window.google.maps is available.

module.exports = function() {
  const b = true,
    f = false;
  function g(a) {
    const c = a || {};
    this.d = this.c = f;
    if (a.visible == undefined) a.visible = b;
    if (a.shadow == undefined) a.shadow = '7px -3px 5px rgba(88,88,88,0.7)';
    if (a.anchor == undefined) a.anchor = i.BOTTOM;
    this.setValues(c);
  }
  g.prototype = new google.maps.OverlayView();
  window.RichMarker = g;
  g.prototype.getVisible = function() {
    return this.get('visible');
  };
  g.prototype.getVisible = g.prototype.getVisible;
  g.prototype.setVisible = function(a) {
    this.set('visible', a);
  };
  g.prototype.setVisible = g.prototype.setVisible;
  g.prototype.s = function() {
    if (this.c) {
      this.a.style.display = this.getVisible() ? '' : 'none';
      this.draw();
    }
  };
  g.prototype.visible_changed = g.prototype.s;
  g.prototype.setFlat = function(a) {
    this.set('flat', !!a);
  };
  g.prototype.setFlat = g.prototype.setFlat;
  g.prototype.getFlat = function() {
    return this.get('flat');
  };
  g.prototype.getFlat = g.prototype.getFlat;
  g.prototype.p = function() {
    return this.get('width');
  };
  g.prototype.getWidth = g.prototype.p;
  g.prototype.o = function() {
    return this.get('height');
  };
  g.prototype.getHeight = g.prototype.o;
  g.prototype.setShadow = function(a) {
    this.set('shadow', a);
    this.g();
  };
  g.prototype.setShadow = g.prototype.setShadow;
  g.prototype.getShadow = function() {
    return this.get('shadow');
  };
  g.prototype.getShadow = g.prototype.getShadow;
  g.prototype.g = function() {
    if (this.c)
      this.a.style.boxShadow = this.a.style.webkitBoxShadow = this.a.style.MozBoxShadow = this.getFlat()
        ? ''
        : this.getShadow();
  };
  g.prototype.flat_changed = g.prototype.g;
  g.prototype.setZIndex = function(a) {
    this.set('zIndex', a);
  };
  g.prototype.setZIndex = g.prototype.setZIndex;
  g.prototype.getZIndex = function() {
    return this.get('zIndex');
  };
  g.prototype.getZIndex = g.prototype.getZIndex;
  g.prototype.t = function() {
    if (this.getZIndex() && this.c) this.a.style.zIndex = this.getZIndex();
  };
  g.prototype.zIndex_changed = g.prototype.t;
  g.prototype.getDraggable = function() {
    return this.get('draggable');
  };
  g.prototype.getDraggable = g.prototype.getDraggable;
  g.prototype.setDraggable = function(a) {
    this.set('draggable', !!a);
  };
  g.prototype.setDraggable = g.prototype.setDraggable;
  g.prototype.k = function() {
    if (this.c) this.getDraggable() ? j(this, this.a) : k(this);
  };
  g.prototype.draggable_changed = g.prototype.k;
  g.prototype.getPosition = function() {
    return this.get('position');
  };
  g.prototype.getPosition = g.prototype.getPosition;
  g.prototype.setPosition = function(a) {
    this.set('position', a);
  };
  g.prototype.setPosition = g.prototype.setPosition;
  g.prototype.q = function() {
    this.draw();
  };
  g.prototype.position_changed = g.prototype.q;
  g.prototype.l = function() {
    return this.get('anchor');
  };
  g.prototype.getAnchor = g.prototype.l;
  g.prototype.r = function(a) {
    this.set('anchor', a);
  };
  g.prototype.setAnchor = g.prototype.r;
  g.prototype.n = function() {
    this.draw();
  };
  g.prototype.anchor_changed = g.prototype.n;
  function l(a, c) {
    const d = document.createElement('DIV');
    d.innerHTML = c;
    if (d.childNodes.length == 1) return d.removeChild(d.firstChild);
    else {
      for (var e = document.createDocumentFragment(); d.firstChild; )
        e.appendChild(d.firstChild);
      return e;
    }
  }
  function m(a, c) {
    if (c) for (var d; (d = c.firstChild); ) c.removeChild(d);
  }
  g.prototype.setContent = function(a) {
    this.set('content', a);
  };
  g.prototype.setContent = g.prototype.setContent;
  g.prototype.getContent = function() {
    return this.get('content');
  };
  g.prototype.getContent = g.prototype.getContent;
  g.prototype.j = function() {
    if (this.b) {
      m(this, this.b);
      let a = this.getContent();
      if (a) {
        if (typeof a === 'string') {
          a = a.replace(/^\s*([\S\s]*)\b\s*$/, '$1');
          a = l(this, a);
        }
        this.b.appendChild(a);
        const c = this;
        a = this.b.getElementsByTagName('IMG');
        for (var d = 0, e; (e = a[d]); d++) {
          google.maps.event.addDomListener(e, 'mousedown', h => {
            if (c.getDraggable()) {
              h.preventDefault && h.preventDefault();
              h.returnValue = f;
            }
          });
          google.maps.event.addDomListener(e, 'load', () => {
            c.draw();
          });
        }
        google.maps.event.trigger(this, 'domready');
      }
      this.c && this.draw();
    }
  };
  g.prototype.content_changed = g.prototype.j;
  function n(a, c) {
    if (a.c) {
      let d = '';
      if (navigator.userAgent.indexOf('Gecko/') !== -1) {
        if (c == 'dragging') d = '-moz-grabbing';
        if (c == 'dragready') d = '-moz-grab';
      } else if (c == 'dragging' || c == 'dragready') d = 'move';
      if (c == 'draggable') d = 'pointer';
      if (a.a.style.cursor != d) a.a.style.cursor = d;
    }
  }
  function o(a, c) {
    if (a.getDraggable())
      if (!a.d) {
        a.d = b;
        const d = a.getMap();
        a.m = d.get('draggable');
        d.set('draggable', f);
        a.h = c.clientX;
        a.i = c.clientY;
        n(a, 'dragready');
        a.a.style.MozUserSelect = 'none';
        a.a.style.KhtmlUserSelect = 'none';
        a.a.style.WebkitUserSelect = 'none';
        a.a.unselectable = 'on';
        a.a.onselectstart = function() {
          return f;
        };
        p(a);
        google.maps.event.trigger(a, 'dragstart');
      }
  }
  function q(a) {
    if (a.getDraggable())
      if (a.d) {
        a.d = f;
        a.getMap().set('draggable', a.m);
        a.h = a.i = a.m = null;
        a.a.style.MozUserSelect = '';
        a.a.style.KhtmlUserSelect = '';
        a.a.style.WebkitUserSelect = '';
        a.a.unselectable = 'off';
        a.a.onselectstart = function() {};
        r(a);
        n(a, 'draggable');
        google.maps.event.trigger(a, 'dragend');
        a.draw();
      }
  }
  function s(a, c) {
    if (!a.getDraggable() || !a.d) q(a);
    else {
      let d = a.h - c.clientX,
        e = a.i - c.clientY;
      a.h = c.clientX;
      a.i = c.clientY;
      d = parseInt(a.a.style.left, 10) - d;
      e = parseInt(a.a.style.top, 10) - e;
      a.a.style.left = `${d}px`;
      a.a.style.top = `${e}px`;
      const h = t(a);
      a.setPosition(
        a
          .getProjection()
          .fromDivPixelToLatLng(
            new google.maps.Point(d - h.width, e - h.height)
          )
      );
      n(a, 'dragging');
      google.maps.event.trigger(a, 'drag');
    }
  }
  function k(a) {
    if (a.f) {
      google.maps.event.removeListener(a.f);
      delete a.f;
    }
    n(a, '');
  }
  function j(a, c) {
    if (c) {
      a.f = google.maps.event.addDomListener(c, 'mousedown', d => {
        o(a, d);
      });
      n(a, 'draggable');
    }
  }
  function p(a) {
    if (a.a.setCapture) {
      a.a.setCapture(b);
      a.e = [
        google.maps.event.addDomListener(
          a.a,
          'mousemove',
          c => {
            s(a, c);
          },
          b
        ),
        google.maps.event.addDomListener(
          a.a,
          'mouseup',
          () => {
            q(a);
            a.a.releaseCapture();
          },
          b
        ),
      ];
    } else
      a.e = [
        google.maps.event.addDomListener(
          window,
          'mousemove',
          c => {
            s(a, c);
          },
          b
        ),
        google.maps.event.addDomListener(
          window,
          'mouseup',
          () => {
            q(a);
          },
          b
        ),
      ];
  }
  function r(a) {
    if (a.e) {
      for (var c = 0, d; (d = a.e[c]); c++) google.maps.event.removeListener(d);
      a.e.length = 0;
    }
  }
  function t(a) {
    const c = a.l();
    if (typeof c === 'object') return c;
    const d = new google.maps.Size(0, 0);
    if (!a.b) return d;
    const e = a.b.offsetWidth;
    a = a.b.offsetHeight;
    switch (c) {
      case i.TOP:
        d.width = -e / 2;
        break;
      case i.TOP_RIGHT:
        d.width = -e;
        break;
      case i.LEFT:
        d.height = -a / 2;
        break;
      case i.MIDDLE:
        d.width = -e / 2;
        d.height = -a / 2;
        break;
      case i.RIGHT:
        d.width = -e;
        d.height = -a / 2;
        break;
      case i.BOTTOM_LEFT:
        d.height = -a;
        break;
      case i.BOTTOM:
        d.width = -e / 2;
        d.height = -a;
        break;
      case i.BOTTOM_RIGHT:
        d.width = -e;
        d.height = -a;
    }
    return d;
  }
  g.prototype.onAdd = function() {
    if (!this.a) {
      this.a = document.createElement('DIV');
      this.a.style.position = 'absolute';
    }
    if (this.getZIndex()) this.a.style.zIndex = this.getZIndex();
    this.a.style.display = this.getVisible() ? '' : 'none';
    if (!this.b) {
      this.b = document.createElement('DIV');
      this.a.appendChild(this.b);
      const a = this;
      google.maps.event.addDomListener(this.b, 'click', () => {
        google.maps.event.trigger(a, 'click');
      });
      google.maps.event.addDomListener(this.b, 'mouseover', () => {
        google.maps.event.trigger(a, 'mouseover');
      });
      google.maps.event.addDomListener(this.b, 'mouseout', () => {
        google.maps.event.trigger(a, 'mouseout');
      });
    }
    this.c = b;
    this.j();
    this.g();
    this.k();
    const c = this.getPanes();
    c && c.overlayImage.appendChild(this.a);
    google.maps.event.trigger(this, 'ready');
  };
  g.prototype.onAdd = g.prototype.onAdd;
  g.prototype.draw = function() {
    if (!(!this.c || this.d)) {
      let a = this.getProjection();
      if (a) {
        let c = this.get('position');
        a = a.fromLatLngToDivPixel(c);
        c = t(this);
        this.a.style.top = `${a.y + c.height}px`;
        this.a.style.left = `${a.x + c.width}px`;
        a = this.b.offsetHeight;
        c = this.b.offsetWidth;
        c != this.get('width') && this.set('width', c);
        a != this.get('height') && this.set('height', a);
      }
    }
  };
  g.prototype.draw = g.prototype.draw;
  g.prototype.onRemove = function() {
    this.a && this.a.parentNode && this.a.parentNode.removeChild(this.a);
    k(this);
  };
  g.prototype.onRemove = g.prototype.onRemove;
  var i = {
    TOP_LEFT: 1,
    TOP: 2,
    TOP_RIGHT: 3,
    LEFT: 4,
    MIDDLE: 5,
    RIGHT: 6,
    BOTTOM_LEFT: 7,
    BOTTOM: 8,
    BOTTOM_RIGHT: 9,
  };
  window.RichMarkerPosition = i;
};
